import { createElement, memo } from '@hfe/max';
import View from '@hfe/max-view';
import Image from '@hfe/max-image';
import Text from '@hfe/max-text';
import './SuggestAreaItem.scss';
import RichTextList from '../RichTextList/RichTextList';
import { Actions } from '../../../store';
import { useCallback } from '@max/max';
function SuggestAreaItem(p) {
    var _a, _b, _c, _d;
    const Icon = {
        uri: p.areaSuggest.iconUrl,
        height: 42,
        width: 42
    };
    let title = [];
    let subtitle = [];
    try {
        if ((_a = p.areaSuggest) === null || _a === void 0 ? void 0 : _a.title) {
            title = (_b = JSON.parse(p.areaSuggest.title)) === null || _b === void 0 ? void 0 : _b.richtextlist;
        }
        if ((_c = p.areaSuggest) === null || _c === void 0 ? void 0 : _c.subTitle) {
            subtitle = (_d = JSON.parse(p.areaSuggest.subTitle)) === null || _d === void 0 ? void 0 : _d.richtextlist;
        }
    }
    catch (error) {
        console.log(error);
    }
    const onSelect = useCallback(() => {
        p.dispatchEvent && p.dispatchEvent({
            type: Actions.updateCitySelection,
            data: {
                value: p.areaSuggest.cityId,
                label: p.areaSuggest.cityName
            }
        });
        p.dispatchEvent && p.dispatchEvent({
            type: Actions.toggleCitySelection,
            data: false
        });
    }, [p]);
    return <View className="suggest-area-item-container" onClick={onSelect}>
      <View className="suggest-area-item-left">
        <Image className="suggest-area-item-icon" source={Icon} resizeMode={'cover'}/>
        <View className="suggest-area-item-title">
          <RichTextList x-if={title && title.length > 0} richTextList={title} isSubTitle={false}/>
          <RichTextList x-if={subtitle && subtitle.length > 0} richTextList={subtitle} isSubTitle={true}/>
        </View>
      </View>
      <View className="suggest-area-item-right">
        <Text className="suggest-area-item-tag-text">{p.areaSuggest.tag}</Text>
      </View>
    </View>;
}
export default memo(SuggestAreaItem);
